import React, { useState, useEffect } from 'react'
import { MultiSelect } from 'react-multi-select-component'
import { onApiAllUserList } from '../../../../Core/Apicall'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../../../Config/Actions/loadingActions'
import { useFormContext } from '../FormProvider'

const AddArtists = () => {
  const [selectedArtists, setSelectedArtists] = useState([])
  const [artists, setArtists] = useState([])
  const [newArtists, setNewArtists] = useState(false)
  const dispatch = useDispatch()
  const { formData, setFormData, errors } = useFormContext()
  const ArtistId = formData.AddArtists

  // Fetch Artists - Run only once
  useEffect(() => {
    const fetchArtists = async () => {
      dispatch(setLoadingTrue())
      try {
        const response = await onApiAllUserList({
          offset: 1,
          limit: 1000000,
          type: ''
        })
        setArtists(response.data || [])
      } catch (error) {
        console.error('Error fetching artist list:', error)
      }
      dispatch(setLoadingFalse())
    }

    fetchArtists()
  }, [dispatch])

  // Update selected artists when ArtistId changes
  useEffect(() => {
    if (ArtistId && ArtistId.length > 0 && artists.length > 0) {
      const selected = ArtistId.map(id => {
        const artist = artists.find(a => a.artistId === id)
        return artist
          ? { label: artist.userName, value: artist.artistId }
          : null
      }).filter(Boolean)

      // Prevent unnecessary re-renders
      if (JSON.stringify(selected) !== JSON.stringify(selectedArtists)) {
        setSelectedArtists(selected)
        setNewArtists(selected.length > 0)
      }
    } else if (selectedArtists.length > 0) {
      setSelectedArtists([])
      setNewArtists(false)
    }
  }, [ArtistId, artists])

  // Handle artist selection change
  const handleChange = selectedItems => {
    setSelectedArtists(selectedItems)
    const ids = selectedItems.map(item => item.value)
    setFormData(prevForm => ({
      ...prevForm,
      AddArtists: ids
    }))
    setNewArtists(selectedItems.length > 0)
  }

  // Handle removing an artist
  const handleRemove = removedItem => {
    const updatedSelectedArtists = selectedArtists.filter(
      item => item.value !== removedItem.value
    )
    setSelectedArtists(updatedSelectedArtists)
    const ids = updatedSelectedArtists.map(item => item.value)
    setFormData(prevForm => ({
      ...prevForm,
      AddArtists: ids
    }))
    setNewArtists(ids.length > 0)
  }

  // MultiSelect options
  const options = artists.map(artist => ({
    label: artist.userName,
    value: artist.artistId
  }))

  return (
    <div
      className={`Category_name AddArtists ${
        errors.AddArtists ? 'invalid' : 'valid'
      }`}
      style={{ width: '100%', marginBottom: '23px', position: 'relative' }}
    >
      <div style={{ position: 'relative', zIndex: '1' }}>
        <div
          className={`artists_id ${
            newArtists ? 'Artists-bold' : 'Artists-bold-d'
          }`}
          style={
            selectedArtists.length === 0
              ? { paddingBottom: '0px' }
              : { paddingBottom: '10px', paddingLeft: '0px' }
          }
        >
          <MultiSelect
            options={options}
            value={selectedArtists}
            onChange={handleChange}
            labelledBy='Add Artists'
            overrideStrings={{ selectSomeItems: 'Add Artists' }}
            className='custom-multiselect'
          />
          <div style={{ display: 'flex', flexWrap: 'wrap',paddingLeft:"10px" }}>
            {selectedArtists.map(artist => (
              <div key={artist.value} className='artist-tag '>
                {artist.label}
                <div
                  className='remove-btn'
                  onClick={() => handleRemove(artist)}
                >
                  X
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddArtists
